export const data = [
    {
        id: 1,
        name:'Yash',
        age:21,
        birthdate: "18/12",
        year:1998,
    },
    {
        id: 2,
        name:'Varad',
        age:20,
        birthdate: "3/9",
        year:1999
    },
    {
        id: 3,
        name:'Shubhankar',
        age:20,
        birthdate: "3/10",
        year:1999
    },
    {
        id: 4,
        name:'Dev',
        age:20,
        birthdate: "19/11",
        year:1999
    },
    {
        id: 5,
        name:'Ishan Dawar',
        age:20,
        birthdate: "5/11",
        year:1999
    },
    {
        id: 6,
        name:'Shrey Mahajan',
        age:19,
        birthdate: "24/7",
        year:1999
    },
    {
        id: 7,
        name:'Shubham Gogia',
        age:20,
        birthdate: "28/8",
        year:1999
    },
    {
        id: 8,
        name:'Swarup Ghosh',
        age:21,
        birthdate: "13/11",
        year:1998
    },
    {
        id: 9,
        name:'Akshat Agarwal',
        age:20,
        birthdate: "29/5",
        year:1999
    },
    {
        id: 10,
        name:'Ishan Jain',
        age:20,
        birthdate: "28/8",
        year:1999
    },
    {
        id: 11,
        name:'Rishabh Jakhar',
        age:20,
        birthdate: "19/2",
        year:1999
    },
    {
        id: 12,
        name:'Rahul Shyokand',
        age:20,
        birthdate: "19/2",
        year:1999
    },
    {
        id: 13,
        name:'Aryan Agarwal',
        age:20,
        birthdate: "27/2",
        year:1999
    },
    {
        id: 14,
        name:'Smahi Shah',
        age:20,
        birthdate: "31/3",
        year:1999
    },
    //dummy data
    {
        id: 15,
        name:'Neel',
        age:20,
        birthdate: "2/11",
        year:1999
    },
    {
        id: 16,
        name:'Hrithik',
        age:20,
        birthdate: "3/11",
        year:1999
    },
    {
        id: 17,
        name:'Ayushman',
        age:20,
        birthdate: "4/11",
        year:1999
    },
    {
        id: 18,
        name:'Kriti',
        age:20,
        birthdate: "5/11",
        year:1999
    },
    {
        id: 19,
        name:'Tuhin',
        age:21,
        birthdate: "6/11",
        year:1999
    },
    {
        id: 20,
        name:'Tanay',
        age:20,
        birthdate: "7/11",
        year:1999
    },
];